module.exports = __webpack_public_path__ + "img/icon_mini_map.d0682151.svg";